export const getInvoiceLink = (invoiceId, invoiceKey) => {
    return `https://app.fawaterk.com/invoice/${invoiceId}/${invoiceKey}`;
};
